import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import {
  faArrowDownToBracket,
  faCoins,
  faFileContract,
  faFileInvoice,
  faFileLines,
  faMemo,
  faMemoCircleCheck,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { deleteFacturaById } from "api/Factura.service"
import { ESTADO_REVISION_DOCUMENTO_COMERCIAL } from "api/Types/EstadoRevisionDocumentoComercial"
import { ESTADOS_COBRO } from "api/Types/EstadosCobro"
import { ESTADOS_PAGO } from "api/Types/EstadosPago"
import { TIPO_DOCUMENTO_ENUM } from "api/Types/TipoDocumentoEnum"
import { useRectificarFactura } from "common/hooks/useRectificarOEditarFactura"
import notification from "common/utils/notification"
import { TYPES_DOCUMENTOS } from "features/Crear/pages/FormCreacionDocumento/constant"
import ModalTypeDownloadDocument from "features/Documentos/components/ModalTypeDownloadDocument/ModalTypeDownloadDocument"
import { useConvertirDocumentoRedirect } from "features/Documentos/hooks/useConvertirDocumentoRedirect.hook"
import { handleDownloadPdfAlbaran } from "features/Documentos/pages/Albaranes/constants/constants"
import { handleDownloadPdfPedido } from "features/Documentos/pages/Pedidos/constants/contants"
import { handleDownloadPdfPresupuesto } from "features/Documentos/pages/Presupuestos/constants/constants"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import DeleteModal from "../Modal/DeleteModal"
import { STATUSCORRECT, TYPES_DOC } from "./constants"

// todo: migrar ts en migracion redux
const ModalVerDocumentoHeader = ({
  refreshData,
  docType,
  document,
  documentoID,
  onHide,
  showActions,
  isVenta,
  setShowModalPagoCobroManual,
  puedeBorrarse,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showModalDownload, setShowModalDownload] = useState<{
    show: boolean
    id: string | null
    serie: string | null
  }>({
    show: false,
    id: null,
    serie: null,
  })
  const deleteFactura = async () => {
    const { status }: { status: number } = await deleteFacturaById(documentoID)
    if (status === STATUSCORRECT) {
      notification.success({ body: `${t("crear.factura.delete")}` })
      setShowDeleteModal(!showDeleteModal)
      refreshData()
      onHide()
    }
  }
  const { handleConvertirDocumento } = useConvertirDocumentoRedirect()

  const { rectificarOeditarFactura } = useRectificarFactura()

  const openDeleteModal = () => setShowDeleteModal(!showDeleteModal)

  const downloadPdf = (id: string, serie: string) => {
    switch (docType) {
      case TYPES_DOC.PRESUPUESTO:
        return handleDownloadPdfPresupuesto(id, serie, t)
      case TYPES_DOC.PEDIDO:
        return handleDownloadPdfPedido(id, serie, t)
      case TYPES_DOC.ALBARAN:
        return handleDownloadPdfAlbaran(id, serie, t)
      case TYPES_DOC.FACTURA:
        return setShowModalDownload({
          show: true,
          id,
          serie: `${serie}`,
        })

      default: {
        throw new Error(`Tipo de documento no soportado}`)
      }
    }
  }

  return (
    <div className='!tw-p-0 tw-flex tw-w-full tw-justify-between tw-items-center'>
      <span className='tw-h-fit tw-p-0'>{document?.serieNumero}</span>
      <div className='tw-flex tw-flex-row tw-justify-end tw-items-center !tw-pt-0 tw-gap-3'>
        <span className='tw-w-auto tw-flex tw-gap-4'>
          {docType === TIPO_DOCUMENTO_ENUM.FACTURA &&
            document?.estadoRevisionActual !==
              ESTADO_REVISION_DOCUMENTO_COMERCIAL.ELIMINADO &&
            puedeBorrarse && (
              <div
                className='tw-w-10 tw-h-10 tw-rounded tw-shadow tw-flex tw-justify-center tw-items-center !tw-p-0 tw-cursor-pointer'
                onClick={openDeleteModal}
              >
                <FontAwesomeIcon
                  icon={["fal", "trash-can"]}
                  className='tw-self-center tw-w-5 tw-h-5 tw-text-danger'
                />
              </div>
            )}
        </span>
        <OptionsMenuStorybook
          id='modalDocumentoOptions'
          items={
            document?.tipoDocumento !== TIPO_DOCUMENTO_ENUM.FACTURA
              ? [
                  {
                    title: `${t("crear.factura.tab.downloadLabel")}`,
                    hasRedirect: true,
                    action: () => {
                      downloadPdf(document?.id, document?.serie)
                    },
                    className: "!tw-font-normal",
                    icon: faArrowDownToBracket,
                  },
                  {
                    title: `${t("crear.presupuesto.tab.convertirLabel")}`,
                    hasRedirect: false,
                    show:
                      isVenta ||
                      document?.tipoDocumento !== TIPO_DOCUMENTO_ENUM.ALBARAN,
                    subMenu: [
                      {
                        title: `${t("asociateDoc.orderLabel")}`,
                        action: () =>
                          handleConvertirDocumento(
                            document,
                            TYPES_DOCUMENTOS.PEDIDO
                          ),
                        className: "!tw-font-normal",
                        show:
                          document?.tipoDocumento ===
                          TIPO_DOCUMENTO_ENUM.PRESUPUESTO,
                        icon: faFileLines,
                      },
                      {
                        title: `${t("asociateDoc.deliveryLabel")}`,
                        action: () =>
                          handleConvertirDocumento(
                            document,
                            TYPES_DOCUMENTOS.ALBARAN
                          ),
                        className: "!tw-font-normal",
                        show:
                          document?.tipoDocumento ===
                            TIPO_DOCUMENTO_ENUM.PRESUPUESTO ||
                          document?.tipoDocumento ===
                            TIPO_DOCUMENTO_ENUM.PEDIDO,
                        icon: faFileContract,
                      },
                      {
                        title: `${t("asociateDoc.invoiceLabel")}`,
                        action: () =>
                          handleConvertirDocumento(
                            document,
                            TYPES_DOCUMENTOS.FACTURA
                          ),
                        show: !!isVenta,
                        className: "!tw-font-normal",
                        icon: faFileInvoice,
                      },
                    ],
                  },
                ]
              : [
                  {
                    title: `${t("crear.factura.tab.downloadLabel")}`,
                    hasRedirect: true,
                    action: () => {
                      downloadPdf(
                        document?.id,
                        document?.serie ?? document?.serieNumero
                      )
                    },
                    className: "!tw-font-normal",
                    icon: faArrowDownToBracket,
                  },
                  {
                    title: `${t("crear.factura.tab.createAmendmentInvoice")}`,
                    hasRedirect: true,
                    action: () => {
                      rectificarOeditarFactura(
                        document?.serie ?? document?.serieNumero,
                        document?.id
                      )
                    },
                    className: "!tw-font-normal",
                    show:
                      isVenta &&
                      document?.estadoRevisionActual !==
                        ESTADO_REVISION_DOCUMENTO_COMERCIAL.BORRADOR &&
                      !(
                        document?.facturaRectificada?.id ||
                        document?.facturaRectificativa?.id
                      ),
                    icon: faMemoCircleCheck,
                  },
                  {
                    title: `${
                      isVenta
                        ? t("crear.factura.tab.markCollected")
                        : t("crear.factura.tab.markPaid")
                    }`,
                    hasRedirect: true,
                    action: () =>
                      setShowModalPagoCobroManual({
                        show: true,
                        id: document?.id,
                        serie: document?.serie,
                      }),
                    className: "!tw-font-normal",
                    show: isVenta
                      ? document?.estadoCobro?.estadoCobro !==
                          ESTADOS_COBRO.COBRADO &&
                        document?.estadoRevisionActual !==
                          ESTADO_REVISION_DOCUMENTO_COMERCIAL.BORRADOR
                      : document?.estadoPago?.estadoPago !==
                          ESTADOS_PAGO.PAGADA &&
                        document?.estadoRevisionActual ===
                          ESTADO_REVISION_DOCUMENTO_COMERCIAL.VALIDADO,
                    icon: faCoins,
                  },
                  {
                    title: `${t("crear.factura.tab.editInvoiceDraft")}`,
                    hasRedirect: true,
                    action: () => {
                      rectificarOeditarFactura(
                        document?.serie ?? document?.serieNumero,
                        document?.id,
                        true
                      )
                    },
                    className: "!tw-font-normal ",
                    show:
                      isVenta &&
                      document?.estadoRevisionActual ===
                        ESTADO_REVISION_DOCUMENTO_COMERCIAL.BORRADOR,
                    icon: faMemo,
                  },
                ]
          }
          buttonClassName={`${showActions ? "" : "!tw-hidden"}`}
          position='right'
        />
        <DeleteModal
          visible={showDeleteModal}
          onHide={() => setShowDeleteModal(!showDeleteModal)}
          size='small'
          iconType='remesas'
          buttonLabel={t("crear.factura.confirm")}
          title={t("crear.factura.titleDelete")}
          message={t("crear.factura.msgDelete")}
          onConfirm={deleteFactura}
        />
        <ModalTypeDownloadDocument
          modalState={showModalDownload}
          onHide={() =>
            setShowModalDownload({
              show: false,
              id: null,
              serie: null,
            })
          }
          showElements={{
            downloadPdf: true,
            downloadXml: true,
          }}
          typeDocument={TIPO_DOCUMENTO_ENUM.FACTURA}
        />
      </div>
    </div>
  )
}

export default ModalVerDocumentoHeader
